import React from 'react';
import { connect } from 'react-redux';
import {
  feedbackPageRequest,
  onClickRow,
  submitReplyRequest,
} from 'actions/customers/feedback';
import { loadLoyaltySubscription } from 'actions/customers/loyalty/loyaltySubscription';
import FeedbackTable from './FeedbackTable';
import FeedbackDetail from './FeedbackDetail';
import styles from './style.feedback.css';
import ActionBar from './ActionBar';
import Subscribe from '../Loyalty/Subscribe';

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    const views = {
      feedback: 'feedback',
      subscribe: 'subscribe',
    };
    const currentView = null;

    this.state = {
      feedbackId: 0,
      feedbackType: '',
      feedbackMode: '',
      views,
      currentView,
    };
  }

  componentWillMount() {
    const { billingNotification } = this.props.data;
    this.props.dispatch(feedbackPageRequest());
    this.props.dispatch(loadLoyaltySubscription(billingNotification));
  }

  componentWillReceiveProps() {
    const { currentView, views } = this.state;

    if (currentView === views.subscribe) {
      return;
    }

    this.setState({ currentView: views.feedback });
  }

  render() {
    const { trialEndAt, outletSlot, alreadySubscribed, isOwner } = this.props;
    const {
      feedback: { feedbackMessages, transactionDetail },
      loyaltySubscription,
    } = this.props.data.customers;
    const { currentView, views } = this.state;

    return (
      <div>
        {currentView === views.feedback && (
          <div id="feedback-list" className={styles.feedback}>
            <ActionBar
              loyaltySubscription={loyaltySubscription}
              goToSubscribeView={this._showSubscribe}
            />
            <div className="mk-customer-feedback moka-container-content">
              <FeedbackTable onClickRow={this._onClickRow} />
              <FeedbackDetail
                feedbackMessages={feedbackMessages}
                onSubmitReply={this._handleSubmit}
                transactionDetail={transactionDetail}
                feedbackType={this.state.feedbackType}
                feedbackMode={this.state.feedbackMode}
              />
            </div>
          </div>
        )}
        {currentView === views.subscribe && (
          <Subscribe
            loyaltySubscription={loyaltySubscription}
            trialEndAt={trialEndAt}
            outletSlot={outletSlot}
            alreadySubscribed={alreadySubscribed}
            isOwner={isOwner}
            onClickCancel={this._showFeedback}
            afterSubscribe={this._showFeedback}
            goToSubscribeView={this._showSubscribe}
          />
        )}
      </div>
    );
  }

  _showFeedback = () => {
    this.props.dispatch(feedbackPageRequest());
    this.setState({ currentView: this.state.views.feedback });
  };

  _showSubscribe = () => {
    this.setState({ currentView: this.state.views.subscribe });
  };

  _onClickRow = feedback => {
    $('#customer-feedback').hide();
    $('#customer-feedback-detail').show();
    this.props.dispatch(onClickRow(feedback));
    this.setState({ feedbackId: feedback.id });
    this.setState({ feedbackType: feedback.feedback_type });
    this.setState({ feedbackMode: feedback.mode });
  };

  _handleSubmit = feedbackData => {
    const { comment, feedbackfrom, business_name, canReply } = feedbackData;
    const id = this.state.feedbackId;
    let commentSanited = '';
    if (feedbackfrom === 'sms') {
      commentSanited = comment.substring(business_name.length);
    } else {
      commentSanited = comment;
    }
    feedbackData = {
      comment: commentSanited,
      feedback_id: id,
      feedback_from: feedbackfrom,
      can_reply: canReply,
    };
    this.props.dispatch(submitReplyRequest(feedbackData));
  };
}

function mapStateToProps(state) {
  const {
    already_subscribed,
    business: { trial_end_at, outlet_slot },
    is_owner,
  } = state.moka.user;

  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,

    data: {
      customers: {
        feedback: state.customers.feedback,
        loyaltySubscription: state.customers.loyaltySubscription,
      },
      form: state.form,
      billingNotification: state.billingNotification,
    },
  };
}

export default connect(mapStateToProps)(Feedback);
